import { Button, Modal } from "antd";

export default function MyBtnConfirm({
  textBtn = "",
  onConfirm,
  icon,
  btnIcon,
  disabled = false,
  mainContent = "",
  mainTitle = "",
  isLoading = false,
  type = "primary",
  fontSize = "",
  ghost = false,
}) {
  const [modal, contextHolder] = Modal.useModal();

  const showConfirm = () => {
    modal.confirm({
      title: mainTitle,
      content: mainContent,

      okText: "Так",
      cancelText: "Скасувати",

      onOk: async () => {
        if (onConfirm) {
          await onConfirm();
        }
      },
      maskClosable: true,
      icon: icon,
    });
  };

  return (
    <>
      {contextHolder}

      <Button
        style={{
          fontSize: fontSize,
        }}
        type={type}
        ghost={ghost}
        onClick={showConfirm}
        loading={isLoading}
        disabled={disabled}
        icon={btnIcon}
      >
        {textBtn}
      </Button>
    </>
  );
}
